import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import cn from 'classnames';
import { Typography, useDevice } from 'seagull';
import s from './TriageRow.module.scss';
export const TriageRow = (param)=>{
    let { label, children, testId } = param;
    const { isMobileDevice } = useDevice();
    return /*#__PURE__*/ _jsxs("div", {
        "data-testid": testId,
        className: cn(s.row, {
            [s.rowMobile]: isMobileDevice
        }),
        children: [
            /*#__PURE__*/ _jsx(Typography, {
                className: s.label,
                children: label
            }),
            typeof children === 'string' ? /*#__PURE__*/ _jsx(Typography, {
                weight: "normal",
                className: s.value,
                children: children
            }) : /*#__PURE__*/ _jsx("div", {
                className: s.value,
                children: children
            })
        ]
    });
};
